import Background from '@commons/background/Background'
import { CampaignProps } from '@commons/types'
import { PbPropsProvider, usePbProps } from '@content/helpers/src/context'
import { getPBProps } from '@content/helpers/src/utils.ts'
import CTA from '@commons/cta/CTA.tsx'
import styles from './HeroHome.module.scss'
import { CopywritingProps, PBProps } from './types'
import useImpressionTracker from '@content/helpers/src/hooks/useImpressionTracker'
import { useRef, useEffect } from 'preact/hooks'
import SectionHeader from '@commons/section-header/SectionHeader'

type HeroHomeProps = {
    data: string
}
const Buttons = () => {
    const {
        copywriting,
        campaign
    }: { copywriting: CopywritingProps; campaign: CampaignProps } = usePbProps()

    return (
        <div className={styles.buttons}>
            {copywriting.cta_primary?.link && (
                <CTA
                    {...copywriting.cta_primary}
                    campaign={campaign}
                    tracking_select_promotion={`LINK - 1 - ${copywriting.cta_primary.label}`}
                />
            )}
            {copywriting.cta_secondary?.link && (
                <CTA
                    campaign={campaign}
                    tracking_select_promotion={`LINK - 2 - ${copywriting.cta_secondary.label}`}
                    {...copywriting.cta_secondary}
                />
            )}
        </div>
    )
}

export const getOverlayType = (overlay, position) => {
    if (!overlay || !position) {
        return 'gradient-left'
    }
    if (!overlay || overlay == 'full') {
        return overlay
    } else {
        return `${overlay}-${position}`
    }
}

function HeroHome({ data }: HeroHomeProps) {
    const pbProps = getPBProps<PBProps>(data)
    const { campaign, layout, copywriting } = pbProps as PBProps

    const containerRef = useRef(null)

    useImpressionTracker(containerRef, campaign)

    const positions = {
        left: styles['left'],
        'left-corner': styles['left-corner'],
        bottom: styles['bottom'],
        center: styles['center'],
        undefined: styles['left']
    }

    useEffect(() => {
        const header = document.getElementById('header') as HTMLElement
        const countryMsg = document.querySelector(
            '.HeaderCountryMessage'
        ) as HTMLElement

        const headerHeight = header?.offsetHeight || 200
        const countryMsgHeight = countryMsg?.offsetHeight || 0

        const totalOffset = headerHeight + countryMsgHeight

        document.documentElement.style.setProperty(
            '--hero-offset-height',
            `${totalOffset}px`
        )
    }, [])

    return (
        <div ref={containerRef} className={`${styles.heroHome}`}>
            <PbPropsProvider value={pbProps}>
                <Background
                    overlay={getOverlayType(layout?.overlay, layout?.align)}
                    {...layout?.background}
                    video={layout?.background_video}
                    className={styles.video}
                />
                <div
                    className={`${styles.heroHomeWrapper} ${positions[layout?.align]}`}>
                    <div className={styles.headingWrapper}>
                        <SectionHeader
                            headlineTag="h1"
                            contrast={layout.contrast}
                            headline={copywriting.heading}
                            subhead={copywriting.subhead}
                            description={copywriting.description}
                        />
                    </div>
                    <Buttons />
                </div>
            </PbPropsProvider>
        </div>
    )
}

export default HeroHome
